import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useWorkspace } from "@/contexts/WorkspaceContext";

export type LeadSheet = "hot" | "cold" | "refresher" | "products" | null;

const SHEET_LABELS: Record<string, string> = {
  hot: "Hot Leads",
  cold: "Cold Leads",
  refresher: "Refresher",
  products: "Products",
};

export function useCurrentLeadSheet(): {
  sheet: LeadSheet;
  label: string | null;
  groupName: string | null;
  fullLabel: string | null;
} {
  const { pathname } = useLocation();
  const { workspace, selectedGroupId } = useWorkspace();
  const [groupName, setGroupName] = useState<string | null>(null);

  const match = pathname.match(/\/(hot|cold|refresher|products)(?:\/|$)/);
  const sheet = (match?.[1] as LeadSheet) ?? null;
  const label = sheet ? SHEET_LABELS[sheet] : null;

  useEffect(() => {
    let cancelled = false;

    if (workspace === "groups" && selectedGroupId) {
      supabase
        .from("groups")
        .select("name")
        .eq("id", selectedGroupId)
        .single()
        .then(({ data }) => {
          if (!cancelled) {
            setGroupName(data?.name ?? null);
          }
        });
    } else {
      setGroupName(null);
    }

    return () => {
      cancelled = true;
    };
  }, [workspace, selectedGroupId]);

  const fullLabel = label
    ? workspace === "groups"
      ? groupName
        ? `${groupName} · ${label}`
        : `Group · ${label}`
      : `Personal · ${label}`
    : null;

  return { sheet, label, groupName, fullLabel };
}
